import React from 'react'

import cn from '../../libs/class-names'

import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'

export interface Props {
  classNames?: string[]
  size?: 'default' | 'l'
  invert?: boolean
  onClick?: React.MouseEventHandler
  title?: string
}

const CloseButton = ({classNames, size = 'default', invert = false, title, onClick}: Props) => (
  <button
    type="button"
    className={cn('CloseButton', {invert, [`size-${size}`]: true}, classNames)}
    onClick={onClick}
  >
    <Icon block source={closeIcon} title={title} />
  </button>
)

export default CloseButton
